import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LocalStorageService } from 'app/services/local-storage.service';
import { TUTORIAL_VIDEOS, tutorialVideoUrl } from 'app/helpers/tutorial-videos';

@Component({
  selector: 'app-proposal-appearence-tutorial-modal',
  templateUrl: './proposal-appearence-tutorial-modal.component.html',
  styleUrls: ['./proposal-appearence-tutorial-modal.component.scss']
})
export class ProposalAppearenceTutorialModalComponent implements OnInit {
  videoUrl = tutorialVideoUrl(TUTORIAL_VIDEOS.customizeProposal);

  constructor(
    public dialogRef: MatDialogRef<ProposalAppearenceTutorialModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _localStorage: LocalStorageService,
  ) { 
  }
  
  ngOnInit(): void {
    this.dialogRef.afterClosed().toPromise().then(()=>{
        console.log("dialog clozedddd");
        this._localStorage.setItem('showProposalAppearenceTutorial', false);
    });
  }

  dismissModalOnStorage(): void {
    this.dialogRef.close()
  }

}
